import { render, staticRenderFns } from "./niceCase.vue?vue&type=template&id=3955d90c&scoped=true&"
import script from "./niceCase.vue?vue&type=script&lang=js&"
export * from "./niceCase.vue?vue&type=script&lang=js&"
import style0 from "./niceCase.vue?vue&type=style&index=0&id=3955d90c&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3955d90c",
  null
  
)

export default component.exports